export enum RegistrationUnsuccessReason {
    Excluded, // is in register of excluded players
    Invalid, // has invalid record in population register
    BlockedFor7Days, // has cancelled account in last 7 days
    Risky, // there is risk connected to citizenship
}
